import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentUrlService } from './environment-url.service';

@Injectable({
  providedIn: 'root'
})
export class BookCoverApiService {
  private baseUrl = 'book-project';

  constructor(private http: HttpClient, private envUrl: EnvironmentUrlService) {}

  private createCompleteRoute(route: string, envAddress: string): string {
    return `${envAddress}/${this.baseUrl}/${route}`;
  }

  uploadBookCover(bookProjectId: string, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(this.createCompleteRoute(`${bookProjectId}/cover/upload`, this.envUrl.apiUrl), formData);
  }

  getBookCover(bookProjectId: string): Observable<Blob> {
    return this.http.get(this.createCompleteRoute(`${bookProjectId}/cover`, this.envUrl.apiUrl), { responseType: 'blob' });
  }

  generateBookCover(bookProjectId: string, style: string, userPrompt?: string): Observable<Blob> {
    const body = { style, userPrompt };
    return this.http.post(this.createCompleteRoute(`${bookProjectId}/cover/generate`, this.envUrl.apiUrl), body, { responseType: 'blob' });
  }
}
